module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Dashboard1_16"],"path":[{"$":{"d":"M9,6h7V16H9ZM9,4h7V0H9ZM0,16H7V11H0ZM0,9H7V0H0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Dashboard1_16.svg
// module id = jYCv
// module chunks = 1